// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PncqvI7Op2p_so {
  display: flow-root;
  z-index: 10;
  min-height: 24px;
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px) var(--ds-space-050, 4px);
  display: flex;
  position: relative;
  flex-direction: column;
  min-height: 60px;
}
.DI_ngqSupZOx_s {
  border-bottom-right-radius: var(--ds-border-radius-200, 8px);
  border-bottom-left-radius: var(--ds-border-radius-200, 8px);
  background-color: rgba(255, 255, 255, 0.7);
}
:where(html[data-color-mode='dark']) .DI_ngqSupZOx_s {
  background-color: rgba(29, 33, 37, 0.7);
}
.aKrJXPnqas65fV {
  flex: 1;
}
.HhxcLFJUJLAhuZ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;
  margin-top: auto;
}
.xGIM_Um4dDqm_b {
  display: flex;
  flex: 1;
  align-items: center;
}
.wgaUtl9QB_Hd8_ {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-left: var(--ds-space-100, 8px);
}
.wgaUtl9QB_Hd8_ button {
  padding: var(--ds-space-050, 4px) var(--ds-space-150, 12px);
  font-size: 12px;
  line-height: 16px;
}
`, ""]);
// Exports
export var details = `PncqvI7Op2p_so`;
export var stickersBackdrop = `DI_ngqSupZOx_s`;
export var cardContent = `aKrJXPnqas65fV`;
export var cardFooter = `HhxcLFJUJLAhuZ`;
export var cardFooterContent = `xGIM_Um4dDqm_b`;
export var plannerCta = `wgaUtl9QB_Hd8_`;
export default ___CSS_LOADER_EXPORT___;
